import routeName from "./routeName.filter";

const routeNameModule = angular
  .module("app.filters.routeName", [])
  .filter("routeName", routeName);

export default routeNameModule;



// WEBPACK FOOTER //
// ./src/filters/routeName/routeName.module.js